import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";

export class Catalog extends DataObject {
    _type = "catalog";

    id;
    name;
}

export class CatalogFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {Object, null} data Data to construct the Catalog object with. Also creates a Meta object using MetaFactory if data is not null.
     * @returns {Catalog}
     */
    static construct(_catalogMapper, data = null) {
        if (data != null) {
            let catalog = DataObjectFactory.getInstance().construct(
                Catalog,
                data ? _catalogMapper(data) : null
            );

            return catalog;
        }

        return null;
    }
}
